var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 23 15",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15.0254 6.12671C16.6854 6.12671 18.0154 4.78671 18.0154 3.12671C18.0154 1.46671 16.6854 0.126709 15.0254 0.126709C13.3654 0.126709 12.0254 1.46671 12.0254 3.12671C12.0254 4.78671 13.3654 6.12671 15.0254 6.12671ZM7.02539 6.12671C8.68539 6.12671 10.0154 4.78671 10.0154 3.12671C10.0154 1.46671 8.68539 0.126709 7.02539 0.126709C5.36539 0.126709 4.02539 1.46671 4.02539 3.12671C4.02539 4.78671 5.36539 6.12671 7.02539 6.12671ZM7.02539 8.12671C4.69539 8.12671 0.0253906 9.29671 0.0253906 11.6267V14.1267H14.0254V11.6267C14.0254 9.29671 9.35539 8.12671 7.02539 8.12671ZM15.0254 8.12671C14.7354 8.12671 14.4054 8.14671 14.0554 8.17671C15.2154 9.01671 16.0254 10.1467 16.0254 11.6267V14.1267H22.0254V11.6267C22.0254 9.29671 17.3554 8.12671 15.0254 8.12671Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }